import { render, staticRenderFns } from "./Actes.vue?vue&type=template&id=d57243b6&"
import script from "./Actes.vue?vue&type=script&lang=js&"
export * from "./Actes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports